import React from 'react';
import { StorefrontOutlined } from '@mui/icons-material';
import { LoadingIndicator, PageContainer } from '../../../../common/components/styled-ui-elements';

interface VendorLoadingStateProps {
  message?: string;
}

const VendorLoadingState: React.FC<VendorLoadingStateProps> = ({
  message = 'Loading...',
}) => {
  return (
    <PageContainer>
      <LoadingIndicator icon={StorefrontOutlined} message={message} minHeight="50vh" />
    </PageContainer>
  );
};

export default VendorLoadingState;
